import { h } from 'preact';
import styled, { keyframes } from 'styled-components';

const loadingAnimation = keyframes`
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
`;

export const SkeletonItem = styled.div`
  height: 20px;
  width: 100%;
  background-color: #e0e0e0;
  margin-bottom: 10px;
  animation: ${loadingAnimation} 1.5s infinite;
`;

export const SkeletonLoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SkeletonLoader = () => {
  return (
    <SkeletonLoaderContainer>
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
    </SkeletonLoaderContainer>
  );
};

export default SkeletonLoader;
